var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../../templates/results/pv_building.results.template.html');

var TheView = GenericView.extend({
    el: '#tab2',
    tagName: '',
	template: Handlebars.compile(Template),
	data: null,
	frontEndData: null,
	months: [{number:1, name: 'January'}, {number:2, name: 'February'}, {number:3, name: 'March'}, {number:4, name: 'April'}, {number:5, name: 'May'}, {number:6, name: 'June'}, {number:7, name: 'July'}, {number:8, name: 'August'}, {number:9, name: 'September'}, {number:10, name: 'October'}, {number:11, name: 'November'}, {number:12, name: 'December'}],
	timeTable: [],
	initialize: function (options) {
	    this.data = options.data;
	    this.timeTable = GenericView.prototype.createTimeTable();
        this.render();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template({data: this.data, months: this.months, timeTable: this.timeTable}));
    },
    events: {

    },
});

module.exports= TheView;